import API from "./API.js";
import axios from "axios";

export default class Semester extends API {
  constructor() {
    super("semester");
  }
  async setActive(eduProgramId, id) {
    try {
      const response = await axios.get(
        `semester/setactive/${eduProgramId}/${id}`
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;
      }
    }
  }

  async getSemesters() {
    try {
      const response = await axios.get(`get_semesters`);
      return response.data;
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;
      }
    }
  }

  async getSubjects(id) {
    try {
      const response = await axios.get(`get_semesters_subject_codes/${id}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;
      }
    }
  }
}
